import { digitsEnToFa, digitsFaToEn } from 'persian-tools2';
import {
  patientDiabetType,
  patientInsulinType,
  patientPregnancyType
} from 'utils/functions-utils';

export const createPatientData = ({
  birthDate,
  isMale,
  diabetType,
  insulinType,
  isUsingOralMedications,
  yearsWithDiabet,
  isPregnant,
  serialNumber,
  phoneNumber
}) => [
  {
    title: 'تاریخ تولد',
    value: birthDate ? digitsEnToFa(birthDate) : '_',
    id: 1
  },
  {
    title: 'جنسیت',
    value: isMale ? 'مرد' : isMale === false ? 'زن' : '_',
    id: 2
  },
  {
    title: 'نوع دیابت',
    value: patientDiabetType(diabetType),
    id: 3
  },
  {
    title: ' انسولین',
    value:
      insulinType === null
        ? '_'
        : digitsEnToFa(patientInsulinType(insulinType)),
    id: 4
  },
  {
    title: 'داروی خوراکی',
    value:
      (isUsingOralMedications === true && 'بله') ||
      (isUsingOralMedications === false && 'خیر') ||
      (isUsingOralMedications === null && '_'),
    id: 5
  },
  {
    title: 'زمان شروع دیابت',
    value:
      yearsWithDiabet == null
        ? '_'
        : yearsWithDiabet > 0
        ? `${digitsEnToFa(yearsWithDiabet)} سال`
        : 'زیر یک سال',
    id: 6
  },
  {
    title: 'وضعیت بارداری',
    value: patientPregnancyType(isPregnant),
    id: 7
  },
  {
    title: ' سریال دستگاه',
    value: serialNumber ? digitsFaToEn(serialNumber) : '_',
    id: 9
  }
];
